// extracted by mini-css-extract-plugin
export default {"hero":"Start_hero__-auHE","text":"Start_text__tcf5R"};